"use strict";

import angular from "angular";

import template from "./table-search-header.component.html";
import "./table-search-header.component.scss";

/**
 * Rótulo ao lado da lupa.
 *
 * Era opt-in e só o Domínio pedia — as outras vinte e cinco telas mostravam a lupa sozinha, que
 * depende de o usuário já saber o que ela abre. Agora o rótulo é o padrão e a tela que quer outra
 * palavra passa `toggle-label`; `toggle-label=""` volta ao ícone puro.
 */
const DEFAULT_TOGGLE_LABEL = "Pesquisar";

export class TableSearchHeaderComponent {
    opened = false;

    constructor($rootScope, $element, $timeout, TableSearchService) {
        this.$rootScope = $rootScope;
        this.$element = $element;
        this.$timeout = $timeout;
        this.TableSearchService = TableSearchService;
    }

    $onInit() {
        this.opened = this.TableSearchService.isOpened();
    }

    $postLink() {
        if (this.hintOnHover === false) return;

        this.tables = this.getTables();
        if (!this.tables.length) return;

        this.onEnterTable = () => this.showHint();
        this.onLeaveTable = () => this.hideHint();

        this.tables.forEach((table) => {
            table.addEventListener("mouseenter", this.onEnterTable);
            table.addEventListener("mouseleave", this.onLeaveTable);
        });
    }

    $onDestroy() {
        this.tables?.forEach((table) => {
            table.removeEventListener("mouseenter", this.onEnterTable);
            table.removeEventListener("mouseleave", this.onLeaveTable);
        });
    }

    getTables() {
        const table = this.$element[0].closest("table");
        if (!table) return [];

        const block = table.closest(".desnu-table-basic-header-fixed");
        const scope = block?.parentElement;

        return scope ? Array.from(scope.querySelectorAll("table")) : [table];
    }

    getTooltip() {
        return this.$element[0].querySelector(".table-search-header__toggle")
            ?._tippy;
    }

    /**
     * Enquanto o ponteiro está sobre a tabela, o tooltip é nosso.
     *
     * O tippy nasce com gatilho `mouseenter focus` e `hideOnClick`, então ele se escondia
     * sozinho assim que o ponteiro cruzava o próprio botão ou a um clique em qualquer lugar —
     * mesmo com o mouse ainda na tabela. Em modo manual ninguém o esconde além de nós.
     */
    showHint() {
        if (this.opened) return;
        // Com o rótulo na tela, o balão diz o que já está escrito logo abaixo dele — e ainda tapa
        // o cabeçalho da tabela a cada passagem do mouse. A dica existe para quando só há a lupa.
        if (this.showLabel()) return;
        const tooltip = this.getTooltip();
        if (!tooltip) return;
        tooltip.setProps({ trigger: "manual", hideOnClick: false });
        tooltip.show();
    }

    hideHint() {
        const tooltip = this.getTooltip();
        if (!tooltip) return;
        tooltip.hide();
        tooltip.setProps({ trigger: "mouseenter focus", hideOnClick: true });
    }

    /**
     * Só renderiza a contagem quando a tela passa uma — as demais telas não usam o binding.
     *
     * Zero não rende selo, pela mesma razão do `FilterCountBadge` do v2: uma bolinha com "0" chama
     * atenção para o que não existe, e quem já mostra o vazio é o estado vazio da própria tabela.
     */
    hasCount() {
        return this.count !== null && this.count !== undefined && this.count > 0;
    }

    /** Ver `DEFAULT_TOGGLE_LABEL`. String vazia é escolha explícita da tela, não ausência. */
    label() {
        return this.toggleLabel === undefined || this.toggleLabel === null
            ? DEFAULT_TOGGLE_LABEL
            : this.toggleLabel;
    }

    /** Some com a busca aberta: aí o campo já diz o que é, e o botão vira o "fechar". */
    showLabel() {
        return !this.opened && !!this.label();
    }

    onToggle() {
        this.opened = !this.opened;
        this.TableSearchService.setOpened(this.opened);
        this.hideHint();

        if (!this.opened) {
            const hadSearchText = !!this.TableSearchService.get();
            this.TableSearchService.reset();

            if (hadSearchText) {
                this.$rootScope.$broadcast("onTypeHeaderInput", {
                    searchText: ""
                });
            }
            return;
        }

        this.$timeout(() =>
            this.$element[0]
                .querySelector(".table-search-header__input input")
                ?.focus()
        );
    }
}

TableSearchHeaderComponent.$inject = [
    "$rootScope",
    "$element",
    "$timeout",
    "TableSearchService"
];

const name = "tableSearchHeaderComponent";
const def = {
    controller: TableSearchHeaderComponent,
    transclude: true,
    bindings: {
        placeholder: "@",
        hintOnHover: "<",
        count: "<",
        /** Texto ao lado da lupa. Ver `DEFAULT_TOGGLE_LABEL`. */
        toggleLabel: "@"
    },
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
